module.exports = __webpack_public_path__ + "img/jacobus_01.3cecdf4b.png";